import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_check_tasks_by_material_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { material_ids: number[] }): 
  Promise<{ result: { Count?: number, MaterialId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_ids)) {
      $missingRequiredInParams.push('\'material_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { material_ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Count?: number, MaterialId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_ids)) {
      $missingRequiredInParams.push('\'material_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { material_ids: number[], $keys: number[] }): 
  Promise<{ result: { Count?: number, MaterialId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.material_ids)) {
      $missingRequiredInParams.push('\'material_ids\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      material_ids: number[]    }) {
        if(isNil($inParams.material_ids)) {
          return true; 
        }
      return false;
    }
}
